import { useQuery } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { OlapScoresQuery } from "src/context/OlapScores/useOlapScoresParams";
import { zodParseWithDetailedLog } from "src/utils/zodErrorLogger";
import { OlapScoresSchema } from "./olapScoresSchema";

type Options = {
    postId: number | undefined;
    scoresQuery?: OlapScoresQuery;
};

export const getPostScoresKey = "getPostScores" as const;

export const useGetPostScores = (options: Options) => {
    const { postId, scoresQuery } = options;

    return useQuery({
        queryKey: [getPostScoresKey, postId, scoresQuery],
        enabled: postId !== undefined,
        cacheTime: 0,
        queryFn: async () => {
            const url = `/api/ssq-posts/${postId}/scores`;

            return loggedInApiCall.get(url, {
                params: scoresQuery,
            });
        },
        select: (request) => {
            const data = zodParseWithDetailedLog(request.data, OlapScoresSchema, {
                operation: "GET",
                endpoint: "/ssq-posts/:id/scores",
            });
            return data;
        },
    });
};
